import { combineReducers, createStore, applyMiddleware } from 'redux';
import thunk from 'redux-thunk';
import { composeWithDevTools } from 'redux-devtools-extension';
import persistState from 'redux-localstorage';
import * as Sentry from '@sentry/react';

import cart from './cart';
import user from './user';
import compareActivities from './compareActivities';

const reducers = combineReducers({
    cart,
    user,
    compareActivities
});

const sentryReduxEnhancer = Sentry.createReduxEnhancer({
    // Optionally pass options listed below
});

const store = createStore(
    reducers,
    composeWithDevTools(
        applyMiddleware(thunk),
        persistState('user', {
            slicer: () => ({ user: u, cart: c, compareActivities: a }) => ({
                user: u,
                cart: c,
                compareActivities: a
            })
        }),
        sentryReduxEnhancer
    )
);

export default store;
